import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';

/** Work hours count per days of week */
export interface WorkScheduleHoursInterface {
  /** Number of working hours on Monday */
  monday: number;
  /** Number of working hours on Tuesday */
  tuesday: number;
  /** Number of working hours on Wednesday */
  wednesday: number;
  /** Number of working hours on Thursday */
  thursday: number;
  /** Number of working hours on Friday */
  friday: number;
  /** Number of working hours on Saturday */
  saturday: number;
  /** Number of working hours on Sunday */
  sunday: number;
}

const HOURS_VALIDATOR = yup
  .number()
  .integer(DtoMessageEnum.NOT_INTEGER)
  .min(0, DtoMessageEnum.INVALID_DAY_HOURS)
  .max(24, DtoMessageEnum.INVALID_DAY_HOURS);

/** Work hours count per days of week - create/update request body DTO schema */
export const WorkScheduleHoursDto = SerdeDtoClass.create<WorkScheduleHoursInterface>(SecurityDtoKeysEnum.WORK_SCHEDULE_HOURS_DTO, {
  monday: {
    label: 'Понедельник',
    serializer: HOURS_VALIDATOR,
  },
  tuesday: {
    label: 'Вторник',
    serializer: HOURS_VALIDATOR,
  },
  wednesday: {
    label: 'Среда',
    serializer: HOURS_VALIDATOR,
  },
  thursday: {
    label: 'Четверг',
    serializer: HOURS_VALIDATOR,
  },
  friday: {
    label: 'Пятница',
    serializer: HOURS_VALIDATOR,
  },
  saturday: {
    label: 'Суббота',
    serializer: HOURS_VALIDATOR,
  },
  sunday: {
    label: 'Воскресенье',
    serializer: HOURS_VALIDATOR,
  },
});
